class Duid {
  constructor() {}
  randomString() {
    var result = "";
    var chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var length = 20;
    for (var i = length; i > 0; --i)
      result += chars[Math.round(Math.random() * (chars.length - 1))];

    localStorage.setItem("duid-ibakatv", result);
    return result;
  }

  getDuid() {
    var duid = localStorage.getItem("duid-ibakatv");
    if (!duid) {
      this.randomString();
      duid = localStorage.getItem("duid-ibakatv");
    }
    return duid;
  }
}

const duid = new Duid();

export default duid;
